var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-link',{staticClass:"logo",attrs:{"route":"page-meditation/list"}},[_c('img',{attrs:{"src":"/assets/img/logo.svg","alt":"Logo"}}),_vm._v(" "),_c('div',{staticClass:"logo-name"},[_vm._v("Медитация")])])}
var staticRenderFns = []

export { render, staticRenderFns }